import { FunctionComponent } from "react";

import { faLocationPin } from "@fortawesome/pro-regular-svg-icons";

import { faLocationDot } from "@fortawesome/pro-light-svg-icons";

import { ListPerson } from "@/pages/Private/pages/List/schema/list";
import { Tooltip } from "@/components/Tooltip/Tooltip";
import { Icon } from "@/components";

export const OrgLocation: FunctionComponent<{
	row: ListPerson;
}> = ({ row }) => {
	return (
		<div className="flex flex-row gap-2 items-center w-full min-w-0">
			<Tooltip
				className="min-w-0 overflow-hidden "
				content={
					<>
						<div>HQ: {row.prospect?.organization?.country}</div>
					</>
				}
			>
				{row.prospect?.organization?.country && (
					<div className="text-sm text-status-info truncate text-left flex flex-row items-center gap-1 min-w-0">
						<Icon className="text-gray-500  w-3.5 h-3.5  shrink-0" icon={faLocationDot} />
						{row.prospect?.organization?.country}
					</div>
				)}
			</Tooltip>
		</div>
	);
};
